import React, { useMemo } from 'react';
import { useContainerQuery } from '../../hooks/useContainerQuery.ts';
import { DialogPortal } from './Portal/DialogPortal.tsx';
import { DialogBackdrop } from './Backdrop/DialogBackdrop.tsx';
import { DialogPopup } from './Popup/DialogPopup.tsx';
import { DialogTitle } from './Title/DialogTitle.tsx';
import { DialogImageTitle } from './ImageTitle/DialogImageTitle.tsx';
import { DialogContent } from './Content/DialogContent.tsx';
import { DialogLegacyContent } from './LegacyContent/DialogLegacyContent.tsx';
import { DialogFooter } from './Footer/DialogFooter.tsx';
import { DialogButtonFooter } from './ButtonFooter/DialogButtonFooter.tsx';
import { DialogConfirmButton } from './ConfirmButton/DialogConfirmButton.tsx';
import { DialogCancelButton } from './CancelButton/DialogCancelButton.tsx';
import { useDialogTracking } from './UseDialogTracking.ts';
import { DialogContext } from './DialogContext.ts';
const COMPACT_QUERY = {
    isShort: {
        maxHeight: 360
    },
    isNarrow: {
        maxWidth: 370
    },
    isImageNarrow: {
        maxWidth: 320
    }
};
function DialogComponent({ open = true, onClose, size = 'md', children }) {
    useDialogTracking(open, onClose);
    const [{ isShort, isNarrow, isImageNarrow }, backdropRef] = useContainerQuery(COMPACT_QUERY);
    const isCompact = isShort || isNarrow;
    const hasCompactImage = isShort || isImageNarrow;
    const contentSize = isCompact ? 'compact' : size;
    const imageTitleSize = hasCompactImage ? 'compact' : size;
    const contextValue = useMemo(()=>({
            onClose: onClose,
            size: contentSize,
            imageTitleSize: imageTitleSize
        }), [
        onClose,
        contentSize,
        imageTitleSize
    ]);
    if (!open) return null;
    return /*#__PURE__*/ React.createElement(DialogContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ React.createElement(DialogPortal, null, /*#__PURE__*/ React.createElement(DialogBackdrop, {
        containerRef: backdropRef
    }), /*#__PURE__*/ React.createElement(DialogPopup, null, children)));
}
const DialogButtonFooterWithButtons = Object.assign(DialogButtonFooter, {
    ConfirmButton: DialogConfirmButton,
    CancelButton: DialogCancelButton
});
export const Dialog = Object.assign(DialogComponent, {
    Title: DialogTitle,
    ImageTitle: DialogImageTitle,
    Content: DialogContent,
    LegacyContent: DialogLegacyContent,
    Footer: DialogFooter,
    ButtonFooter: DialogButtonFooterWithButtons
});
